<script setup>
// Módulo para trabalhar com data e hora
// por enquanto módulo está configurado para trabalhar só com data
// A máscara por default está a letra L que significa YY/MM/DDDD
// Caso tenha dúvida desse componente, acesse: https://vcalendar.io/

import { DatePicker } from 'v-calendar';
import 'v-calendar/dist/style.css';
import { ref, defineEmits, onUpdated, computed } from 'vue';
import { dateTimeUtil } from '@/utils/';

const inputRef = ref();
const datePickerProps = ref();

const emits = defineEmits(['onUpdate:modelValue', 'getDate']);

const props = defineProps({
  isDateStringWithTime: {
    type: Boolean,
    default: false,
  },
  isIso: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

// Fiz uma padronização onde, se for setado no componente o props isDateTime como true,
// reconfiguro toda a propriedade para trabalhar com hora.

const maskDateModelValue = computed(() => {
  if (props.isDateStringWithTime) {
    return 'DD/MM/YYYY HH:mm:ss';
  }
  if (props.isIso) {
    return 'iso';
  }
  return 'DD/MM/YYYY';
});
const getMaskDateInput = computed(() => (props.isDateStringWithTime ? '##/##/#### ##:##' : '##/##/####'));
const getModeDate = computed(() => (props.isDateStringWithTime ? 'dateTime' : 'date'));

// função que vai verificar se a data está default(01/01/1990), caso esteja
// iremos limpar tanto o props quanto o valor do campo input
function updateDateTimeValueDefault() {
  if ((datePickerProps.value === dateTimeUtil.getStringDateDefault || datePickerProps.value === dateTimeUtil.getStringDateDefaultLocate || !datePickerProps.value) && inputRef.value.modelValue === '') {
    datePickerProps.value = '';
    emits('onUpdate:modelValue', datePickerProps.value);
    inputRef.value.updateValue(datePickerProps.value, inputRef.value.modelConfig);
  } else {
    emits('getDate', datePickerProps.value);
  }
}

onUpdated(() => {
  updateDateTimeValueDefault();
});
</script>

<template>
  <DatePicker :is24hr="props.isDateStringWithTime" :mode=getModeDate :locale="'pt'" :model-config="{type: 'string', mask: maskDateModelValue}" v-model="datePickerProps" :popover="{visibility: 'focus'}" ref="inputRef" HideTimeHeader>
    <template v-slot="{inputValue, inputEvents}">
      <input v-maska :data-maska=getMaskDateInput class="form-control" :value="inputValue" v-on="inputEvents" @blur="$emit('getDate')" :disabled="props.disabled" />
    </template>
  </DatePicker>
</template>
